import { createRouter, createWebHistory } from 'vue-router'
import AppLayout from '@/layout/AppLayout.vue';
import LoadingForm from '../views/LoadingForm.vue';
import LoginForm from '../views/LoginForm.vue';
import UsersForm from '../views/UsersForm.vue';
import EntitiesForm from '../views/EntitiesForm.vue';
import EntitieValuesForm from '../views/EntitieValuesForm.vue';
import ErrorForm from '../views/ErrorForm.vue'
import DashboardsForm from '../views/DashboardsForm.vue';
import SystemForm from '../views/SystemForm.vue';


import store from '../store';

const routes = [
    {
        path: '/',
        component: LoadingForm,
    },
    {
        path: '/App',
        component: AppLayout,
        beforeEnter: AuthGuard,
        children: [
            {
                path: 'Users',
                name: 'UsersForm',
                component: UsersForm
            },
            {
                path: 'Entities',
                name: 'EntitiesForm',
                component: EntitiesForm
            },
            {
                path: 'EntitieValues',
                name: 'EntitieValuesForm',
                component: EntitieValuesForm
            },
            {
                path: 'Dashboards/:formName',
                name: 'DashboardsForm',
                component: DashboardsForm
            },
            {
                path: 'System',
                name: 'SystemForm',
                component: SystemForm
            },
        ]
    },
    {
        path: '/Login',
        component: LoginForm,
    },
    {
        path: '/ERROR',
        name: 'ErrorForm',
        component: ErrorForm,
    },
]

function AuthGuard(from, to, next) {
    if (store.getters.isUserAuthenticated)
        next();
    else
        next('/Login')
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
